// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__luM1V"};